import React, { Fragment, useEffect, useState } from "react";
import { Form, Input, message, Modal, Radio } from "antd";
import { OrdersRepository, OrderState } from "../../../../../domain";
import { ServiceLocater, Services } from "../../../../../service-locater";
import I18n from "../../../../i18n";
import { loadOrders } from "../../../../../application/orders-slice";
import { useAppDispatch } from "../../../../../application/store";
import { logger } from "../../../../../utils";

type EditOrderStateProps = {
  visible: boolean;
  onClose: () => void;
  currentState?: OrderState;
  orderId?: string;
  currentPage: number;
};

const EditOrderState: React.FC<EditOrderStateProps> = ({
  visible,
  onClose,
  orderId,
  currentState,
  currentPage,
}) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedState, setSelectedState] = useState(currentState);
  const [form] = Form.useForm();
  const [postalTrackingCode, setPostalTrackingCode] = useState<string>();

  useEffect(() => {
    setSelectedState(currentState);
  }, [currentState]);

  const submit = async () => {
    try {
      if (orderId === undefined || selectedState === undefined) return;
      if (selectedState === "POSTED") await form.validateFields();
      setIsLoading(true);
      const res = await ServiceLocater.get<OrdersRepository>(
        Services.OrdersRepository
      ).edit(orderId, selectedState, postalTrackingCode);
      setIsLoading(false);
      res.fold(
        (_) => {
          message.error(I18n.general.networkError);
        },
        (_) => {
          onClose();
          message.success("وضعیت سفارش با موفقیت تغییر یافت");
          dispatch(loadOrders(currentPage));
        }
      );
    } catch (error) {
      logger.error(error);
    }
  };

  return (
    <Modal
      title={"تغییر وضعیت سفارش"}
      visible={visible}
      closable={!isLoading}
      maskClosable={!isLoading}
      onCancel={isLoading ? undefined : onClose}
      onOk={submit}
      confirmLoading={isLoading}
    >
      <Radio.Group
        disabled={isLoading}
        onChange={(e) => setSelectedState(e.target.value)}
        value={selectedState}
      >
        <Radio style={{ display: "block" }} value={"PENDING"}>
          در اتنظار پرداخت
        </Radio>
        <Radio style={{ display: "block" }} value={"PAID"}>
          پرداخت شده
        </Radio>
        <Radio style={{ display: "block" }} value={"POSTED"}>
          پست شده
        </Radio>
        <Radio style={{ display: "block" }} value={"DELIVERED"}>
          تحویل شده
        </Radio>
      </Radio.Group>
      {selectedState === "POSTED" ? (
        <Form
          form={form}
          fields={[{ name: "postal-tracking-code", value: postalTrackingCode }]}
        >
          <Form.Item
            label="کد پیگیری پست"
            name="postal-tracking-code"
            rules={[{ validateTrigger: "onSubmit", required: true }]}
          >
            <Input
              name="postal-tracking-code"
              disabled={isLoading}
              allowClear
              inputMode="numeric"
              onChange={(v) => {
                const value = v.target.value;
                const numberRegex = /^[0-9\b]+$/;
                if (value === "" || numberRegex.test(value)) {
                  setPostalTrackingCode(value);
                }
                form.setFields([
                  {
                    name: "phone",
                    value: postalTrackingCode ? postalTrackingCode : "",
                  },
                ]);
              }}
            />
          </Form.Item>
        </Form>
      ) : (
        <Fragment />
      )}
    </Modal>
  );
};

export default EditOrderState;
